import { keyframes } from '@chakra-ui/react';
import { getColor } from '@chakra-ui/theme-tools';
var fade = keyframes({
  from: {
    backgroundPosition: '-200px 0'
  },
  to: {
    backgroundPosition: 'calc(200px + 100%) 0'
  }
});
var baseStyle = function baseStyle(props) {
  var defaultStartColor = 'gray.100';
  var defaultEndColor = 'white';
  var _props$startColor = props.startColor,
    startColor = _props$startColor === void 0 ? defaultStartColor : _props$startColor,
    _props$endColor = props.endColor,
    endColor = _props$endColor === void 0 ? defaultEndColor : _props$endColor,
    _props$speed = props.speed,
    speed = _props$speed === void 0 ? 1.2 : _props$speed,
    theme = props.theme;
  var start = getColor(theme, startColor);
  var end = getColor(theme, endColor);
  return {
    bg: start,
    bgGradient: "linear(to-r, ".concat(start, ", ").concat(end, ", ").concat(start, ")"),
    backgroundSize: '200px 100%',
    backgroundRepeat: 'no-repeat',
    borderRadius: 'base',
    animation: "".concat(fade, " ").concat(speed, "s ease-in-out infinite")
  };
};
var Skeleton = {
  baseStyle: baseStyle
};
export { Skeleton as default };